import { call, put, takeEvery, all } from "redux-saga/effects";

import {
  GET_PAYMENT_REQUEST_DATA,
  GET_PAYMENT_COMPLETE_DATA,
} from "./actionType";

import {
  getPaymentRequestDataSuccess,
  getPaymentRequestDataFailure,
  getPaymentCompleteDataSuccess,
  getPaymentCompleteDataFailure,
} from "./action";

import {
  getPaymentRequestDataApi,
  getPaymentCompleteDataApi,
} from "../../helpers/fakebackend_helper";

//GET_PAYMENT_REQUEST_DATA
function* getPaymentRequestData({ payload }) {
  try {
    const response = yield call(getPaymentRequestDataApi, payload);
    yield put(getPaymentRequestDataSuccess(response));
  } catch (error) {
    yield put(getPaymentRequestDataFailure(error));
  }
}

// Watcher Saga
function* watchGetPaymentRequestData() {
  yield takeEvery(GET_PAYMENT_REQUEST_DATA, getPaymentRequestData);
}
//GET_PAYMENT_COMPLETE_DATA
function* getPaymentCompleteData({ payload }) {
  try {
    const response = yield call(getPaymentCompleteDataApi, payload);
    yield put(getPaymentCompleteDataSuccess(response));
  } catch (error) {
    yield put(getPaymentCompleteDataFailure(error));
  }
}
// Watcher Saga
function* watchGetPaymentCompleteData() {
  yield takeEvery(GET_PAYMENT_COMPLETE_DATA, getPaymentCompleteData);
}

// Root Saga
export default function* PublicPayment() {
  yield all([watchGetPaymentRequestData(), watchGetPaymentCompleteData()]);
}
